<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col s12">
        <div class="card">
          <div class="card-title primary white-text">
            {{ cardTitle }}
          </div>

          <div class="card-content valign-wrapper">
            <div v-if="loadingList" class="progress">
              <div class="indeterminate"></div>
            </div>
            <div v-if="errorList !== ''" class="center-align">
              {{ errorList }}
            </div>

            <div v-if="paymentStatus === '1'" class="center-align" style="width:100%;">
              <div v-if="isGift">
                Thank you for completing your payment.<br>
                We'll send you an email with a personalised gift certificate,
                to send to your intended recipient.
              </div>
              <div v-else>
                Thank you for completing your payment.<br><br>
                Now, you can inform us where to deliver your books.

                <div class="col s12 center-align mt-4">
                  <a @click="goToRegister" class="btn primary waves-effect waves-light">
                    <i class="material-icons right">chevron_right</i>
                    Continue
                  </a>
                </div>
              </div>
            </div>

            <div v-if="paymentStatus === '0'" class="center-align" style="width:100%;">
              There was an error processing your payment, but do not worry.<br>
              If funds have been debited from your account, we should
              either receive them in a couple of hours
              or the funds will be credited back to your account.<br>
              Message us on 9826612456 for any queries. Happy reading!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// Import the API functions
import httpApi from '@/utils/api'

export default {
  props: ['requestID'],

  data () {
    return {
      // Loading status for list of items
      loadingList: true,

      invoiceID: '',
      paymentStatus: '',
      uniqueLink: '',

      errorList: ''
    }
  },

  mounted () {
    // Check status of payment using request ID
    if (this.requestID !== '') {
      this.getPaymentStatus()
        .then(() => {
          this.loadingList = false
        })
        .catch((err) => {
          this.loadingList = false

          // If request ID does not exist
          this.errorList = err.message

          // Show error message
          this.$store.dispatch('SHOW_STATUS_MESSAGE', {
            color: 'error',
            message: err.message
          })
        })
    }
  },

  computed: {
    // Get vuex store data, to be used in this component
    ...mapGetters(['isGift', 'isAuthenticated']),

    cardTitle () {
      let title = this.paymentStatus === '0' ? 'Payment failed' : (this.ifGift ? 'Thank you for gifting Bookshelf!' : 'You\'re almost done!')
      return title
    }
  },

  methods: {
    getPaymentStatus () {
      // Promise a return
      return new Promise((resolve, reject) => {
        httpApi.callWithKey({
          url: 'subscription-payment?requestID=' + this.requestID,
          method: 'get'
        })
          .then((resp) => {
            // Assign subscription plan details
            this.invoiceID = resp.data.invoiceID
            this.paymentStatus = resp.data.paymentStatus
            this.uniqueLink = resp.data.uniqueLink
            if (resp.data.isGift === '1') {
              this.$store.commit('SET_GIFT', true)
            }
            resolve()
          })
          // If an error occurs
          .catch((err) => {
            // Error
            reject(err)
          })
      })
    },

    goToRegister () {
      this.$router.push('/register/' + this.uniqueLink)
    }
  }
}
</script>
